/** @hidden */
export function attributeValueContainsToken(attributeName, token) {
    return "[" + attributeName + "~=\"" + token + "\"]";
}
//# sourceMappingURL=selectors.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@stimulus/core/dist/selectors.js
// module id = null
// module chunks = 